<template>
  <v-dialog v-model="visible" max-width="1000">
    <v-card>
      <v-card-title class="text-h6 grey lighten-1">
         <v-avatar class="ml-n2 mr-3">
           <v-img :src="imagenTitulo" />
         </v-avatar>
         {{ objetoAparato.des }}
      </v-card-title>

      <v-card-text class="pa-0">
        <v-tabs v-model="tab" fixed-tabs background-color="#E0E0D0" mobile-breakpoint="0">
          <!-- <v-tabs-slider color="red"></v-tabs-slider> -->
          <v-tab>
            <v-icon class="mr-3">mdi-information-outline</v-icon>{{ $t ('General') }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-3">mdi-comment-processing-outline</v-icon>{{ $t ('Eventos') }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-3">mdi-circle-multiple</v-icon>{{ $t ('Contenido') }}
          </v-tab>
          <v-tab @change="actualizarUltimasOperacionesFechaSeleccionada">
            <v-icon class="mr-3">mdi-folder-eye-outline</v-icon>{{ $t ('Últimas operaciones') }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" touchless>

          <!-- G E N E R A L  -->

          <v-tab-item :eager="true">
            <v-container class="pt-8" fluid>
              <v-row dense justify="center">
                <v-col cols="3" class="d-flex justify-end">
                  {{ $t ('Identificación') }}:
                </v-col>
                <v-col cols="6" class="fuente-negrita">
                  {{ $t ('Cajero') }} {{estadoAparato.machine_number}} ({{estadoAparato.short_name}})<br>
                  {{estadoAparato.long_name}}<br>
                </v-col>
              </v-row>
              <v-row dense justify="center">
                <v-col cols="3" class="d-flex justify-end">
                  {{ $t ('Versión') }}:
                </v-col>
                <v-col cols="6" class="fuente-negrita">
                  {{estadoAparato.version}}
                </v-col>
              </v-row>
              <v-row v-if="estadoAparato.shift" dense justify="center" class="mt-5">
                <v-col cols="3" class="d-flex justify-end">
                  {{ $t ('Turno') }}:
                </v-col>
                <v-col cols="6" class="fuente-negrita">
                  {{ estadoAparato.safeGet ('shift.number') }} ({{ fechaInicioTurno }})
                </v-col>
              </v-row>
              <v-row dense justify="center">
                <v-col cols="3" class="d-flex justify-end">
                  {{ $t ('Estado') }}:
                </v-col>
                <v-col cols="6" class="fuente-negrita">
                  <v-chip v-if="!estadoAparato.on_line" color="red" outlined class="mr-1 mb-1"><v-icon left>mdi-help-network</v-icon>{{$t ('Off line')}}</v-chip>
                  <v-chip v-if="estadoAparato.alarm_ringing" color="red" outlined class="mr-1 mb-1"><v-icon left>mdi-alarm-light</v-icon>{{$t ('Alarma activada')}}</v-chip>
                  <v-chip v-if="estadoAparato.on_line && !estadoAparato.main_door_closed" color="red" outlined class="mr-1 mb-1"><v-icon left>mdi-door-open</v-icon>{{$t ('Puerta abierta')}}</v-chip>
                  <v-chip v-if="estadoAparato.out_of_order" color="red" outlined class="mr-1 mb-1"><v-icon left>mdi-close-octagon</v-icon>{{$t ('Fuera de servicio')}}</v-chip>
                  <v-chip v-if="estadoAparato.exact_amount" color="orange" outlined class="mr-1 mb-1"><v-icon left>mdi-alert-outline</v-icon>{{$t ('Importe exacto')}}</v-chip>
                  <v-chip v-if="estadoAparato.safeGet ('devices.printer.end_of_paper')" color="orange" outlined class="mr-1 mb-1"><v-icon left>mdi-paper-roll-outline mdi-flip-h</v-icon>{{$t ('Sin papel')}}</v-chip>

                  <v-chip v-if="estadoAparato.on_line && !estadoAparato.alarm_ringing && estadoAparato.main_door_closed && !estadoAparato.out_of_order && !estadoAparato.exact_amount && !estadoAparato.safeGet ('devices.printer.end_of_paper')" color="green" outlined class="mr-1 mb-1"><v-icon left>mdi-emoticon-happy-outline</v-icon>{{$t ('Correcto')}}</v-chip>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <!-- E V E N T O S  -->

          <v-tab-item :eager="true">
            <VisorEventosSAGA
              :key="objetoAparato.id_apa"
              :id-instalacion="objetoAparato.id_ins"
              :id-aparato="objetoAparato.id_apa"
              dense
              sin-sombra
            />
          </v-tab-item>

          <!-- C O N T E N I D O  -->

          <v-tab-item :eager="true">
            <v-container class="pt-8 px-6">

              <v-row justify="space-around">
                <v-col v-for="dispensador in estadoAparato.safeGet ('dispensers.collection', [])" :key="dispensador.id" cols="auto">
                  <ProgresoVertical
                    :progreso="dispensador.count"
                    :maximo="dispensador.maximum_load"
                    colorRelleno="auto"
                    :subtitulo="dispensador.count"
                  >Dispensador<br>{{dispensador.value_description}}</ProgresoVertical>
                </v-col>
                <v-col cols="auto">
                  <ProgresoVertical
                      :progreso="estadoAparato.safeGet ('coinbox.fill_level', 0)"
                      colorRelleno="khaki"
                      :subtitulo="estadoAparato.safeGet ('coinbox.total_amount', '...')+' €'"
                    >Cofre de <br>monedas</ProgresoVertical>
                </v-col>
                <v-col cols="auto">
                  <ProgresoVertical
                      :progreso="estadoAparato.safeGet ('banknotesbox.fill_level', 0)"
                      colorRelleno="khaki"
                      :subtitulo="estadoAparato.safeGet ('banknotesbox.total_amount', '...')+' €'"
                    >Cofre de <br>billetes</ProgresoVertical>
                </v-col>
              </v-row>

               <!-- {{estadoAparato}} -->

            </v-container>
          </v-tab-item>

          <!-- U L T I M A S   O P E R A C I O N E S  -->

          <v-tab-item :eager="true">
            <v-container class="pt-4" fluid>
              <v-row dense>
                <v-col cols="auto" class="pr-5">
                  <v-date-picker
                    no-title
                    first-day-of-week="1"
                    scrollable
                    :min="fechaMinima()"
                    :max="fechaMaxima()"
                    v-model="fechaUltimasOperaciones"
                    @input="cargarUltimasOperacionesFecha"
                  ></v-date-picker>
                  <center><v-btn class="d-block" text color="primary" :disabled="!fechaUltimasOperaciones" @click="actualizarUltimasOperacionesFechaSeleccionada"><v-icon class="mr-2">mdi-refresh</v-icon>Actualizar</v-btn></center>
                </v-col>
                <v-col>
                  <div style="position: relative">
                    <div class="mb-1"><span style="font-size: 13px; font-weight: 500; color: #202020">{{literalFechaUltimasOperaciones}}</span></div>
                    <div class="tira-ultimas-operaciones">
                      <pre class="texto-seleccionable" ref="pre-ultimas-operaciones" style="font-size: 13px; white-space:pre-line;">{{listadoUltimasOperaciones}}</pre>
                    </div>
                    <v-overlay v-model="cargandoUltimasOperaciones" absolute color="#FFFFFF" opacity="0.7">
                      <v-progress-circular :size="70" :width="7" color="#87bead" indeterminate></v-progress-circular>
                    </v-overlay>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

        </v-tabs-items>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="visible = false">
          {{ $t ('Cerrar') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DateTime } from "luxon";
import ProgresoVertical from '@/components/ProgresoVertical.vue';
import VisorEventosSAGA from "@/components/VisorEventosSAGA.vue";

export default {
  components: { ProgresoVertical,
                VisorEventosSAGA
              },
  data () {
    return {
      visible: false,
      tab: 0,
      objetoAparato: {},
      estadoAparato: {},
      sagabroker: null,
      fechaUltimasOperaciones: DateTime.now().toFormat("yyyy-MM-dd"),
      cargandoUltimasOperaciones: false,
      literalFechaUltimasOperaciones: '',
      listadoUltimasOperaciones: ''
    }
  },
  computed: {
    imagenTitulo() {
      return process.env.VUE_APP_URL_BASE_FRONTEND + 'assets__static/aparatos/caj_ci0.png';
    },
    fechaInicioTurno() {
      if (this.estadoAparato.shift && this.estadoAparato.shift.opening_date_time)
        return DateTime.fromISO (this.estadoAparato.shift.opening_date_time).toFormat ("cccc, dd-MM-yyyy HH:mm");
      else
        return null;
    }
  },
  methods: {
    inicializarUltimasOperaciones(){
      this.literalFechaUltimasOperaciones = '...';
      this.listadoUltimasOperaciones = '';
    },
    abrirVentana (objetoAparato, estadoAparato, sagabroker) {
      this.inicializarUltimasOperaciones();
      //this.tab = 0;
      this.objetoAparato = objetoAparato;
      this.estadoAparato = estadoAparato;
      this.sagabroker = sagabroker;
      this.cargandoUltimasOperaciones = false;
      if (this.tab == 3)
        this.actualizarUltimasOperacionesFechaSeleccionada();
      this.visible = true;
    },
    fechaMinima() {
      return DateTime.now().minus({days: 15}).toISO();
    },
    fechaMaxima() {
      return DateTime.now().toISO();
    },
    cargarUltimasOperacionesFecha (fecha) {
      this.cargandoUltimasOperaciones = true;
      this.inicializarUltimasOperaciones ();
      this.sagabroker.solicitarUltimasOperaciones (this.objetoAparato.id_ins, this.objetoAparato.num, fecha)
        .then ((mensaje) => {
          this.literalFechaUltimasOperaciones = DateTime.fromISO (mensaje.contenido.fecha).toFormat ("DDDD") + ':';
          this.listadoUltimasOperaciones = mensaje.contenido.listado;
          this.$nextTick(() => {
            if (this.$refs ['pre-ultimas-operaciones'])
              this.$refs ['pre-ultimas-operaciones'].scrollIntoView({ block: 'end' });
          });
        })
        .catch ((e) => {
          console.error (e);
          this.listadoUltimasOperaciones = '(Error al obtener las últimas operaciones)';
        })
        .finally (() => {
          this.cargandoUltimasOperaciones = false;
        });
    },
    actualizarUltimasOperacionesFechaSeleccionada(){
      this.cargarUltimasOperacionesFecha (this.fechaUltimasOperaciones);
    },
  }
}
</script>

<style scoped>
.fuente-negrita {
  color: black;
  font-weight: bolder;
}
.tira-ultimas-operaciones {
  height: 350px;
  min-width: 300px;
  max-width: 650px;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #FFFFF0;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 5px;
}
</style>